<template>
    <teleport to="#modalDrag" ref="modalType">
        <div class="draggable-modal absolute top-0">
            <div class="modal-container shadow-md bg-white relative flex flex-col self-start __absolute z-100" :style="{ top: style.top, left: style.left, width: '20rem' }" ref="dmContainer">
                <span @click="close" class="absolute top-0 right-0 mt-px pt-3 px-3 cursor-pointer text-gray-800 hover:text-red-600">
                    <i @click="close" class="fa fa-times text-xl"></i>
                </span>
                <div @mousedown="startDrag" @mouseup="stopDrag" class="cursor-move text-md font-semibold leading-normal ml-6 mr-8 pt-3 pb-3" v-if="$slots.header">
                    <slot ref="header" name="header">
                        CommodityTrends
                    </slot>
                </div>
                <div class="modal-body overflow-auto px-6 py-2 border-t border-b border-dotted border-gray-100">
                    <slot name="body"></slot>
                </div>
                <div class="modal-footer px-6 py-3" v-if="$slots.footer">
                    <slot name="footer"></slot>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';

const props = defineProps(['overlay']);

const dragging = ref(false);
const style = ref({
    left: `${(window.innerWidth - 320) / 2}px`,
    top: window.scrollY > 0 ? `${window.scrollY}px` : '5rem',
});
const offset = ref({ x: 0, y: 0 });
const element = ref({ x: 0, y: 0 });
const dmContainer = ref(null);

const emit = defineEmits(['close']);

const close = () => {
    emit('close');
};

const startDrag = (e) => {
    dragging.value = true;
    offset.value.x = dmContainer.value.offsetLeft;
    offset.value.y = dmContainer.value.offsetTop;
    element.value.x = e.pageX;
    element.value.y = e.pageY;
};

const drag = (e) => {
    if (dragging.value) {
        style.value.left = `${offset.value.x + e.pageX - element.value.x}px`;
        style.value.top = `${offset.value.y + e.pageY - element.value.y}px`;
    }
};

const stopDrag = () => {
    dragging.value = false;
};

const watchForEscKey = (event) => {
    const isEscape = event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
    if (isEscape) {
        close();
    }
};

onMounted(() => {
    document.addEventListener('keydown', watchForEscKey);
    document.addEventListener('mousemove', drag);
    document.addEventListener('mouseup', stopDrag);
});

onBeforeUnmount(() => {
    document.removeEventListener('keydown', watchForEscKey);
    document.removeEventListener('mousemove', drag);
    document.removeEventListener('mouseup', stopDrag);
});
</script>
